const $ = require('jquery');
import {setElementsFromScope, insertTextAndClean} from "../../utilities/selectorHelpers";
import {createPreventDefault} from '../../utilities/general';
import {merge} from "../../utilities/general";
import _ from "underscore";
import render from "../../utilities/render";
import run from "../../utilities/run";
import QuickBtnGroup from "../QuickBtnGroup/QuickBtnGroup";
import weToggleHandler from './weToggleHandler';
require("./widgetEngine.less");

const modalHtml = require("../../sharedHtml/modal.html");
const baseHtml = require('./html/baseHtml.html');
const feedContainerTemplateHtml = require('./html/globalHtml/feedContainerTemplate.html');
const rowTemplateHtml = require('./html/globalHtml/rowTemplate.html');

const filterGroupCheckboxHtml = require('./html/filterHtml/filterGroupCheckbox.html');
const filterGroupRadioHtml = require('./html/filterHtml/filterGroupRadio.html');
const filterGroupDateRangeHtml = require('./html/filterHtml/filterGroupDateRange.html');
const filterModalBodyHtml = require('./html/filterHtml/filterModalBody.html');
const filterModalBodyGroupHtml = require('./html/filterHtml/filterModalBodyGroup.html');
const childFiltersWrapHtml = require('./html/filterHtml/childFiltersWrap.html');

const searchLinksWrapHtml = require('../../sharedHtml/linkGroup/linkListWrap.html');
const searchLinkTemplateHtml = require('../../sharedHtml/linkGroup/linkTemplate.html');
const searchOptionTemplateHtml = require('../../sharedHtml/linkGroup/optionTemplate.html');


const elementsMap = {
  filterModalBtn: ".we-filter-modal-open",
  pageRefreshBtn: ".we-page-refresh-trigger",
  itemsContainer: ".we-items-container",
  filterContainer: ".we-filter-container",
  loadingOverlay: ".widget-loading-overlay",
  loadMoreBtn: ".load-more-btn",
  loadingInProgress: ".loading-in-progress",
  filterLinkContainer: ".filter-link-container",
  filterLinkBtn: ".filter-link",
  filterLinkSelect: ".filter-by-select",
  feedContainer: ".we-feed-container",
  feedDataDisplay: ".we-feed-data-display"
}

const elementsModalMap = {
  exportTypeToggler: ".export-type-toggler",
  exportDateRangeStart: ".export-date-range-start",
  exportDateRangeEnd: ".export-date-range-end"
}

const buildFilterModalInputListConfig = {
  checkbox: filterGroupCheckboxHtml,
  radio: filterGroupRadioHtml,
  dateRange: filterGroupDateRangeHtml
}

const filterModalElementsMap = {
  tableFilterModalForm: '.tableFilterModal',
  applyFiltersBtn: ".js-apply-filters",
  parentInput: ".filter-modal-input",
  dateRangeInputs: ".func-date-range-input",
  dateRangeStart: ".func-date-range-input#startDate",
  dateRangeEnd: ".func-date-range-input#endDate"
}

// rename to match what this component is...
export default function WidgetEngine(options={}) {
  // functional code for component here
  const els = {};
  const elsModal = {};
  let baseHtmlWrap, baseHtmlEl, filterModal, validator;

  const self = this;

  const opts = merge(options, {});

  let validationOpts = {
    debug: true,
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  }



  const filterModalEls = {};
  let newWeToggler;
  let allTablesHtml;

  self.init = function(){
    buildHtml();
    generateModals();
    weToggleHandlerInit();
    setElements();
    bindElements();
    toggleFilterModalChildInput();
    validateForMoreData(opts.moreData);
    setFilterLinkActive(opts.filterListActive);
  };

  self.showLoadingBtn = function() {
    showLoadingBtn();
  }

  self.hideLoadingBtn = function() {
    hideLoadingBtn();
  }

  self.appendNewData = function(data) {
    appendNewData(data);
  }

  self.setNewData = function(data) {
    setNewData(data);
  }

  self.refreshAfterActionClicked = function(){
    refreshAfterActionClicked();
  }

  self.validateForMoreData = function(moreData) {
    validateForMoreData(moreData);
  }

  self.generateData = function(){
    return generateData();
  }

  self.setFilterLinkActive = function(filterLinkActive){
    setFilterLinkActive(filterLinkActive);
  }

  self.handleNewActiveDataCount = function(newActiveDataCount){
    handleNewActiveDataCount(newActiveDataCount);
  }

  // NOTE: for upcoming story
  // self.onViewToggleCallback = function(){
  //   onViewToggleCallback();
  // }

  function setElements(){
    setElementsFromScope(els, elementsMap, baseHtmlEl);
    setElementsFromScope(filterModalEls, filterModalElementsMap, filterModal);
  }

  function bindElements(){
    els.filterModalBtn.on('click', openFilterModal);
    els.pageRefreshBtn.on('click', onPageRefreshClick);
    els.loadMoreBtn.click(createPreventDefault(onLoadMoreClick));
    // This is here so if user clicks btn while loading, it just returns
    els.loadingInProgress.click(createPreventDefault(function(){return}));
    filterModalEls.applyFiltersBtn.on('click', createPreventDefault(onApplyFiltersClick));
    els.filterLinkBtn.click(setFilterLinkFromBtn);
    els.filterLinkSelect.change(setFilterLinkFromSelect);
    filterModalEls.parentInput.on('change', toggleFilterModalChildInput);

    filterModalEls.dateRangeInputs.datepicker({
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });
    filterModalEls.dateRangeEnd.on('click', ()=> {
      let initDate = filterModalEls.dateRangeStart.datepicker('getDate');
      if (initDate) {
        initDate = moment(initDate).add(1, 'days').toDate();
        filterModalEls.dateRangeEnd.datepicker('setStartDate', initDate);
      } else if (initDate === null) {
        filterModalEls.dateRangeEnd.datepicker('setStartDate', null);
      }
    });
    filterModalEls.dateRangeStart.on('click', ()=> {
      let initDate = filterModalEls.dateRangeEnd.datepicker('getDate');
      if (initDate) {
        initDate = moment(initDate).subtract(1, 'days').toDate();
        filterModalEls.dateRangeStart.datepicker('setEndDate', initDate);
      } else if (initDate === null) {
        filterModalEls.dateRangeStart.datepicker('setEndDate', null);
      }
    });
    validator = filterModalEls.tableFilterModalForm.validate(validationOpts);
    validator.settings.ignore = ":disabled,:hidden";
  }

  function onLoadMoreClick(){
    if(els.loadMoreBtn.hasClass("disabled")){
      return;
    }

    onFetch();
  }

  function onFetch(){
    opts.onFetch && opts.onFetch();
  }

  function onFilter(){
    opts.onFilter && opts.onFilter();
  }

  function showLoadingBtn() {
    els.loadMoreBtn.hide();
    els.loadingInProgress.show();
  }

  function hideLoadingBtn() {
    els.loadingInProgress.hide();
    els.loadMoreBtn.show();
  }

  function buildHtml(){
    const dataset = opts.data.data;
    const tablesHtml = getTableHtml(dataset);

    baseHtmlWrap = render(baseHtml, {
      hasViewToggler: opts.hasViewToggler,
      viewToggler: opts.viewToggler || "",
      filterLinkContainer: renderFilterLinkList(opts.filterList),
      feedContainer: tablesHtml,
      hasLinkContainer: true
    });

    baseHtmlEl = $(opts.target).html(baseHtmlWrap);
  };

  function appendNewData(data){
    opts.data.data = [...opts.data.data, ...data];
    handleNewData(opts.data.data);
  }

  function setNewData(data) {
    opts.data.data = [ ...data];
    handleNewData(opts.data.data);
  }

  function handleNewData(newDataset){
    const tablesHtml = getTableHtml(newDataset);
    els.feedContainer.html(tablesHtml);
  }

  function handleNewActiveDataCount(dataCount){
    if(opts.viewTogglerDataCountTarget){
      $(opts.viewTogglerDataCountTarget).html(dataCount);
    }
  }

  function getTableHtml(data){
    let allTablesHtml;
    if(opts.groupBy){
     let groupedData = _(data).groupBy(opts.groupBy)
      // NOTE - if view is multiple tables, this should create new tables to bottom
       allTablesHtml = _.values(_(groupedData).mapObject(renderTable)).join("");
    } else {
      // NOTE: if one tables, this should just render new rows to add to bottom of table
       allTablesHtml = renderTable(data, opts.header);
    }

    return allTablesHtml;
  }

  function refreshAfterActionClicked(){
    onFilter();
  }

  function renderTable(tableData, header){
    const tableHtml = _(tableData).map(renderRow).join("");
    return render(
      feedContainerTemplateHtml,
      {
        header: header,
        feedListOnload: tableHtml
      }
    )
  }

  function renderRow(rowData) {
    const rowColumns = _(opts.columns).map(({
      data, render
    }) => {
      if (render) {
        return render(data, rowData[data], rowData)
      }
    }).join("")

    return render(rowTemplateHtml, {
      rowColumns: rowColumns
    })
  }

  function renderFilterLinkList(list){
    return render(searchLinksWrapHtml,
      {
        linkList: buildLinkList(list),
        optionList: buildOptionList(list),
        dropdownName: opts.widgetFilters.filterDropdownName || "",
        dropdownId: opts.widgetFilters.filterDropdownId || "",
        dropdownPlaceholder: opts.widgetFilters.filterDropdownPlaceholder || "",
        dropdownMinResultsForSearch: "7"
      }
    )
  }

  function buildLinkList(list){
    return _(list).map(renderLink).join("");
  }

  function buildOptionList(list){
    return _(list).map(renderOption).join("");
  }

  function renderLink(listItem){
    return render(
      searchLinkTemplateHtml, {
        text: listItem.name,
        targetKey: listItem.filterBy,
        linkHref: listItem.href || "#",
        uniqueClass: listItem.uniqueClass || ""
      }
    )
  }

  function renderOption(optItem){
    return render(
      searchOptionTemplateHtml, {
        text: optItem.name,
        targetKey: optItem.filterBy
      }
    )
  }

  function setFilterLinkActive(filterLinkActive){
    els.filterLinkBtn.removeClass("active");

    _.each(els.filterLinkBtn, function(val, key){
      const btnToBeActive = $(val);
      if(btnToBeActive.data("link-info") === filterLinkActive){
        btnToBeActive.addClass("active");
      }
    });

    els.filterLinkSelect.val(filterLinkActive).trigger('change.select2');
  }

  function weToggleHandlerInit(){
    newWeToggler = new weToggleHandler({
      mainEl: baseHtmlEl,
      // NOTE: for upcoming story
      // onViewToggleCallback: function(){
      //   opts.onViewToggleCallback && opts.onViewToggleCallback();
      // }
    })

    newWeToggler.init();
  }

  function setFilterLinkFromBtn(e){
    e.preventDefault();

    const clickedFilter = $(this).data("link-info");

    els.filterLinkContainer.data("filter-link", clickedFilter);
    onApplyFiltersClick();
  }

  function setFilterLinkFromSelect(){
    const selectedFilter = els.filterLinkSelect.val();

    els.filterLinkContainer.data("filter-link", selectedFilter);
    onApplyFiltersClick();
  }

  function generateModals(){
    filterModal = $(render(
      modalHtml, {
        title: opts.filterModal.title,
        subtitle: "Select filters to apply to your " + opts.filterModal.widgetType,
        leftAlignTitle: true,
        topCloseBtn: true,
        autoHideTop: true,
        body: buildFilterModalBody(filterModalBodyHtml, filterModalBodyGroupHtml, opts.widgetFilters.data),
        footerBtns: `
          <a href="#" class="base-btn purple-btn js-apply-filters">Apply</a>
        `
      }
    ));

    baseHtmlEl.append(filterModal);
  }

  // NOTE: on click or change (based on link click or select option change), set variables here
  function generateData() {
    let filterDataArray = getFilterModalData();
    let filterLinkData = els.filterLinkContainer.data("filter-link");
    let searchCriteria = [
      ...filterDataArray
    ]
    searchCriteria = _(searchCriteria).filter((filterData) => {
      return filterData && _.has(filterData, "key") && _.has(filterData, "operation") && _.has(filterData, "value");
    });

    // NOTE: put on change or on click data here for links
    let widgetData = {
      searchCriteria,
      filterLinkData
    };
    return widgetData;
  }

  function getFilterModalData() {
    // filterGroups = {
    //   status: {
    //     key: 'status'
    //     operation: 'equal',
    //     value: ['inStock','lowStock']
    //   },
    // }
    let filterGroups = {}
    _(filterModal.find('input:checked, input[type="text"]')).each((item) => {
      const key = $(item).attr('name');
      const operation = $(item).data('operator');
      const value = $(item).val();
      filterGroups[key] = filterGroups[key] || { value:[] };
      filterGroups[key].value.push(value);
      filterGroups[key].operation = operation;
      filterGroups[key].key = key;
    });
    return _(filterGroups).values();
  }

  function openFilterModal() {
    filterModal.modal("show");
  }

  function onPageRefreshClick(e) {
    e.preventDefault();
    location.reload();
  }

  function closeFilterModal() {
    filterModal.modal("hide");
  }

  function onApplyFiltersClick() {
    let isValid = validateVisibleChildren();
    if (isValid) {
      closeFilterModal();

      onFilter();
    }
  }

  function buildFilterModalBody(bodyTemplate, groupTemplate, list) {
    let modalBody = render(
      bodyTemplate, {
        groupList: buildFilterModalGroupBody(groupTemplate, list),
      }
    );
    return modalBody;
  }

  function buildFilterModalGroupBody(template, list) {
    let filters = _(list).map((item, index)=>{
      if (!item.filterGroupInputs) {
        item.filterGroupInputs = [{}];
      }
      // Add option to allow parental control of name.
      let filterList = buildFilterModalInputList(item, item.filterGroupInputs, item.filterGroupType);
      return render(
        template, {
          title: item.filterGroup,
          filterList: filterList,
          index
        }
      );
    });
    return filters.join('');
  }

  function buildFilterModalInputList(item, list, type) {
    let filterList = _(list).map((input)=>{
      // Example:
      // {
      //   checkbox: filterGroupCheckboxHtml,
      // }
      const filterTemplate = buildFilterModalInputListConfig[type];
      let filterChildren = "";
      if (input.childFilters) {
        filterChildren = buildFilterModalGroupBody(childFiltersWrapHtml, input.childFilters);
      }
      return render(
        filterTemplate, {
          title: input.filterTitle,
          name: input.filterName || item.filterGroupName,
          dateRangeNameStart:item.dateRangeNameStart,
          dateRangeNameEnd:item.dateRangeNameEnd,
          dateRangeStartVal: item.dateRangeStartVal || "",
          dateRangeEndVal: item.dateRangeEndVal || "",
          value: input.filterValue,
          active: input.active,
          operator: input.filterOperator,
          childFiltersHtml: filterChildren
        }
      );
    });
    return filterList.join('');
  }

  function toggleFilterModalChildInput(e) {
    let $self = $(this);
    if ($self.attr('type') === 'radio') {
      toggleFilterModalChildRadios($self);
    };
    let $target = $self.closest('.divider-group').find('.child-filters-entry');
    validator.resetForm();
    // USE BETTER SHOW/HIDE, LOW PRIORITY
    $target.show();
  }

  function toggleFilterModalChildRadios(radioEl) {
    let $radios = radioEl.closest('.input-list-section').find('input[type="radio"]');
    $radios.each(function() {
      let $curRadio = $(this);
      let $target = $curRadio.closest('.divider-group').find('.child-filters-entry');
      // Reset datepicker options.
      filterModalEls.dateRangeInputs.datepicker("setStartDate", false);
      filterModalEls.dateRangeInputs.datepicker("setEndDate", false);
      // USE BETTER SHOW/HIDE, LOW PRIORITY
      $target.find('input[type="text"]').val("");
      $target.hide();
    });
  }

  // Validation
  function validateVisibleChildren(){
    let isValid = false;
    if (filterModalEls.tableFilterModalForm.valid()) {
      isValid = true;
    }
    return isValid;
  }

  function validateForMoreData(moreData){
    //functionality to enable or disable load more btn
    if(moreData){
      els.loadMoreBtn.removeClass("disabled");
    } else {
      els.loadMoreBtn.addClass("disabled");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/WidgetEngine/index.js